"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clipboard = require("clipboard-polyfill");
class ClipboardHelper {
    copyToClipboard(text) {
        clipboard.writeText(text);
    }
}
exports.clipboardHelper = new ClipboardHelper();
